import { getDayOfWeekNameByNumber } from '@/app/common/dateHelper'
import { getStartDayFromScheduleName } from '@/app/common/converters/configuration/startDayFromScheduleToTextConverter'
import { getTimesheetScheduleModeName } from '@/app/common/converters/configuration/timesheetScheduleModeToTextConverter'
import { getTimesheetSettlementTypeName } from '@/app/common/converters/configuration/timesheetSettlementTypeToTextConverter'
import { StartDayFromSchedule } from '@/app/constants/configuration/startDayFromSchedule'
import { TimesheetScheduleMode } from '@/app/constants/configuration/timesheetScheduleMode'

export type TimesheetSettingFormatter = (value: unknown) => string

export const buildTimesheetBasicFormatters = (
  t: (key: string) => string,
): Record<string, TimesheetSettingFormatter> => ({
  startDayFromSchedule: (v) =>
    getStartDayFromScheduleName(
      (v as boolean)
        ? StartDayFromSchedule.StartDayFromScheduleOption
        : StartDayFromSchedule.StartDayAfterFirstActivityInDayOption,
      t,
    ),
  prepareScheduleOnCalculation: (v) =>
    getTimesheetScheduleModeName(
      (v as boolean)
        ? TimesheetScheduleMode.AutoPrepareScheduleFromCalculation
        : TimesheetScheduleMode.StartDayFromScheduleOption,
      t,
    ),
  weekFreeDay: (v) => t(getDayOfWeekNameByNumber(v as number)),
  currentSettlementType: (v) => getTimesheetSettlementTypeName(v as number, t),
  overhoursLimit: (v) => {
    if (!v) return '—'
    const ts = v as string
    const parts = ts.split('.')
    const days = parts.length === 2 ? parseInt(parts[0]) || 0 : 0
    const timePart = parts.length === 2 ? parts[1] : parts[0]
    const hours = parseInt(timePart?.split(':')[0]) || 0
    return `${days * 24 + hours} h`
  },
})
